import { render, staticRenderFns } from "./subject_disease.vue?vue&type=template&id=da6cffd0&scoped=true"
import script from "./subject_disease.vue?vue&type=script&lang=js"
export * from "./subject_disease.vue?vue&type=script&lang=js"
import style0 from "./subject_disease.vue?vue&type=style&index=0&id=da6cffd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6cffd0",
  null
  
)

export default component.exports